import React from 'react';
import { useMobileStatus } from '../../Utils/useMobileStatus';
import './Legend.css';

const Legend = ({ legendData, title, datesForIds }) => {
  const isMobile = useMobileStatus();

  const getDatesForIds = (datesForIds) => {
    if (datesForIds && Object.keys(datesForIds).length > 0) {
      const id = Object.keys(datesForIds)[0];
      return datesForIds[id];
    }
    return '';
  };

  const legendTitle = title || getDatesForIds(datesForIds);

  return (
    <div className="legendContainer">
      {/* Display the title */}
      <div className="legendTitleWrapper">
        {legendTitle && (
          <span className="legendDate">
            {legendTitle}
          </span>
        )}
      </div>
      <div className="legendItemsWrapper">
        {isMobile ? (
          <div style={{ display: 'flex' }}>
            {legendData.map((item, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: '8px',
                    height: '8px',
                    backgroundColor: item.color,
                    marginRight: '5px',
                    marginLeft: '4px',
                    borderRadius: '50%',
                  }}
                />
                <span style={{ fontSize: '11px' }}>{item.label}</span>
              </div>
            ))}
          </div>
        ) : (
          legendData.map((item, index) => (
            <div key={index} className="legenItemParent">
              <span className="legendItem" style={{ backgroundColor: item.color }} />
              <span className="webLegenItemFont">{item.label}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Legend;



// WEBPACK FOOTER //
// ./src/new/Components/Legend/Legend.jsx